import { render, staticRenderFns } from "./TableErrorImportOkr.vue?vue&type=template&id=70e95584&scoped=true"
import script from "./TableErrorImportOkr.vue?vue&type=script&lang=js"
export * from "./TableErrorImportOkr.vue?vue&type=script&lang=js"
import style0 from "./TableErrorImportOkr.vue?vue&type=style&index=0&id=70e95584&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e95584",
  null
  
)

export default component.exports